angular.module('inline-edit', [])
  .directive('inlineEdit', function() {
    return {
      restrict: 'A', // Attribute only directive
      require: '?ngModel', // This directive optionally requires ngModel
      link: function(scope, element, attrs, ngModel) {
        if (!ngModel) return; // Do nothing if no ngModel

        // Initialize the contenteditable with the value from ngModel
        ngModel.$render = function() {
          element.html(ngModel.$viewValue || '');
        };

        // Read data from the contenteditable
        function read() {
          var html = element.html();
          ngModel.$setViewValue(html);
        }

        element.attr('contenteditable', 'true');

        element.on('blur', function() {
          read(); // Update the model when element loses focus
        });

        element.on('keydown', function(event) {
          // Prevent entering new lines
          if (event.key === 'Enter') {
            event.preventDefault();
            element.blur(); // Optionally, lose focus on enter
          }
          // Optionally, prevent special characters except basic punctuation and space
          if (event.key.length === 1 && !event.key.match(/[a-zA-Z0-9.,;:'"?!@#$%^&*()-_+= ]/)) {
            event.preventDefault();
          }
        });

        element.on('paste', function(event) {
          // Prevent pasting of non-plain text and filter out special characters
          event.preventDefault();
          var text = (event.originalEvent || event).clipboardData.getData('text/plain').replace(/[^\w\s.,;:'"?!@#$%^&*()-_+=]/g, '');
          document.execCommand('insertText', false, text);
        });

        element.on('input', function() {
          scope.$apply(read);
        });
      }
    };
  });
